// ======================================================================
// File Name       : SuperUserDetailContainer.js
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Button, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { searchSkin, deleteSkin } from '../../actions/content/ContentDrillSkinAction';
import { MSG_DEL_SKIN } from '../../constants/MessageTemplate';
import ContentDrillSkinDetail from '../../components/content/ContentDrillSkinDetail';
import DialogConfirm from '../../components/DialogConfirm';
import { SELECT_TARGET_DATA, MODE } from '../../constants/index';
import { canAccessRoute } from '../../utils/AuthedUtils';
import {
  CONTENT,
  CONTENT_DRILL_SKIN,
  CONTENT_DRILL_SKIN_LIST,
} from '../../constants/PathConstants';
import { CONTENT_DRILL_SKIN_EDIT } from '../../constants/FunctionConstants';
import { SKIN_SECERN_ID_DEFAULT } from '../../constants/ContentConstant';
import { shouldHideBackBtn } from '../../utils/index';
import Header from '../../components/Header';
import * as Path from '../../constants/PathConstants';
import CustomLink from '../../components/button/CustomLink';

class ContentDrillSkinDetailContainer extends Component {
  constructor() {
    super();
    this.state = {
      showDelete: false,
      skinSetInfo: {},
      skinSetSecernId: '',
    };
    this.onOkDelete = this.onOkDelete.bind(this);
    this.onCancelDelete = this.onCancelDelete.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    if (match.params.id) {
      const skinSetSecernId = match.params.id;
      this.getSkinList(skinSetSecernId);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { skinSetSecernId } = this.state;
    const { content } = nextProps;
    const { skinListResult } = content;
    const skinSetInfo =
      skinListResult && $.grep(skinListResult.skinList, e => e.skinSetSecernId === skinSetSecernId);
    if (skinSetSecernId) {
      if (skinSetInfo && skinSetInfo.length > 0) {
        this.setState({
          skinSetInfo: skinSetInfo[0],
        });
      } else {
        this.props.history.push(CONTENT_DRILL_SKIN_LIST);
      }
    } else {
      this.props.history.push(CONTENT_DRILL_SKIN_LIST);
    }
  }

  componentWillUnmount() {
    this.setState({
      skinSetInfo: {},
      skinSetSecernId: '',
    });
  }

  /**
     * Get skin list
     *
     */
  getSkinList(skinSetSecernId) {
    this.setState({ skinSetSecernId });
    const param = {
      skinSetSecernId,
    };
    this.props.dispatch(searchSkin(param));
  }

  /**
   * Show delete skin confirm dialog
   * @param mdContent
   * @param mdSize
   */
  openDeleteDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showDelete: true });
  }

  /**
   * Cancel delete skin
   */
  onCancelDelete() {
    this.setState({ showDelete: false });
  }

  /**
   * Confirm delete skin
   */
  onOkDelete() {
    const { skinSetSecernId } = this.state;
    const param = {
      skinSetSecernId,
    };
    this.props.dispatch(deleteSkin(param, this.props.history));
    this.setState({ showDelete: false });
  }

  backPage() {
    this.props.history.goBack();
  }

  render() {
    const { skinSetInfo } = this.state;
    const skinSetSecernId = skinSetInfo && skinSetInfo.skinSetSecernId;
    const link = skinSetInfo
      ? `/${CONTENT}/${CONTENT_DRILL_SKIN}/${skinSetSecernId}/edit`
      : null;
    const canEditDelete = canAccessRoute(CONTENT_DRILL_SKIN_EDIT) &&
                          SKIN_SECERN_ID_DEFAULT.indexOf(skinSetSecernId) < 0;
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.CONTENT_DRILL_SKIN_LIST}
          text="スキン一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="スキン情報の詳細"/>
        <ContentDrillSkinDetail {...this.state} />
        <Col sm={12} className="text-center margin-top-20">
          {canEditDelete &&
          <Link
            className="btn btn-primary btn-96 margin-10"
            role="button"
            to={link}
          >
            編集
          </Link>}
          {canEditDelete &&
          <Button
            variant="primary"
            className="btn-96 margin-10"
            onClick={this.openDeleteDialog.bind(this, MSG_DEL_SKIN, null)}
          >
            削除
          </Button>}
        </Col>
        <DialogConfirm
          showModal={this.state.showDelete}
          onCancel={this.onCancelDelete}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onOkDelete}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ content: state.content },
});

export default connect(mapStateToProps)(ContentDrillSkinDetailContainer);
